export enum TextCanvasTableElementAlignType {
  Left = 'left',
  Center = 'center',
  Right = 'right',
}
